import type { SVGProps } from 'react';
const SvgFastforwardClockStreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Fastforward Clock Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M9.25 4.625V9.25h3.304" />
      <path d="M17.18 5.946A8.592 8.592 0 0 0 .66 9.25a8.59 8.59 0 0 0 16.95 1.982" />
      <path d="M17.84 2.643v3.303h-3.304" />
    </g>
  </svg>
);
export default SvgFastforwardClockStreamlineCore;
